import { memo } from "react";

const ICON_PATHS = {
  active: "/icons/ActiveFire.svg",
  inactive: "/icons/UnactiveFire.svg",
  blue: "/icons/MoneyFire.svg",
  red: "/icons/RedFire.svg",
  black: "/icons/FireBlack.svg",
  white: "/icons/FireWhite.png"
} as const;

// Предзагрузка иконок
Object.values(ICON_PATHS).forEach(path => {
  const img = new Image();
  img.src = path;
});

export const FireIcon = memo(({
  active,
  width = '100%',
  height = '100%'
}: {
  active: keyof typeof ICON_PATHS;
  width?: string | number;
  height?: string | number;
}) => {
  return <img src={ICON_PATHS[active]} alt="fire" width={width} height={height} />;
});

FireIcon.displayName = 'FireIcon';
